module.exports = __webpack_public_path__ + "static/media/dsb-CIGARETTES-TOBACCO.c71f744a.jpg";